import { render, staticRenderFns } from "./TrocaAmbiente.vue?vue&type=template&id=7311bfae&scoped=true&"
import script from "./TrocaAmbiente.vue?vue&type=script&lang=js&"
export * from "./TrocaAmbiente.vue?vue&type=script&lang=js&"
import style0 from "./TrocaAmbiente.vue?vue&type=style&index=0&id=7311bfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7311bfae",
  null
  
)

export default component.exports